import * as Style from '@util/style'
import {
  ButtonDefault,
  ButtonPrimary,
  Logo,
  mediaBreakpointUp,
  useTrackViewAnonymous
} from '@util/ui'
import lodash from 'lodash'
import plates from './benefit-offer-mobile.png'

interface IProps {
  organization: string
  onLinkAccount: () => void
  onCreateAccount: () => void
}

const BenefitOffer: React.FC<IProps> = ({
  organization,
  onLinkAccount,
  onCreateAccount
}) => {
  useTrackViewAnonymous('my_web:viewed_offer_with_organization')

  return (
    <div
      css={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 0,
        minHeight: '100%',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        backgroundImage:
          'linear-gradient(180deg, #FFFFFF 87.07%, #F8F8F8 100%)',

        [mediaBreakpointUp('sm')]: {
          backgroundImage: 'none'
        }
      }}
    >
      <img
        src={plates}
        alt="Two yummy dinners"
        css={{
          position: 'absolute',
          top: '3rem',
          right: 0,
          height: '68vh',

          [mediaBreakpointUp('md')]: {
            display: 'none'
          }
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          maxHeight: 680,
          maxWidth: 448,
          marginTop: ' auto',
          marginBottom: ' auto',
          marginLeft: ' auto',
          marginRight: ' auto'
        }}
      >
        <div>
          <Logo
            width={140}
            style={{
              color: Style.COLOR.GREY_800,
              marginBottom: 6,
              marginLeft: '-0.5rem'
            }}
          />
          <div
            css={{
              maxWidth: 145,
              fontWeight: 300,
              fontSize: '1rem',
              color: '#999',
              lineHeight: 1.3,
              marginLeft: '1.05rem',

              [mediaBreakpointUp('md')]: {
                maxWidth: '50%'
              }
            }}
          >
            meal planning made easy with healthy stress-free recipes
          </div>
        </div>
        <div>
          <div
            css={{
              maxWidth: '70%',
              color: Style.COLOR.GREY_800,
              lineHeight: 1.2,
              fontSize: '1.5rem',
              letterSpacing: -0.33,
              marginTop: '2rem',

              '@media (min-width: 374px)': {
                fontSize: '2rem'
              },

              [mediaBreakpointUp('md')]: {
                maxWidth: 'none'
              }
            }}
          >
            Employees of <br />
            <strong style={{ color: Style.COLOR.GREY_800 }}>
              {lodash.startCase(organization)}
            </strong>{' '}
            get free access to Mealime Pro!
          </div>
          <div
            style={{
              fontSize: '0.875rem',
              color: Style.COLOR.GREY_700,
              lineHeight: '1.4',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              borderTopColor: Style.COLOR.GREY_300,
              marginTop: '2.5rem',
              paddingTop: '1rem'
            }}
          >
            Already have a Mealime account? Link your account to gain access to
            Mealime Pro.
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '1.5rem'
            }}
          >
            <ButtonPrimary shadow onClick={onCreateAccount}>
              Create Account
            </ButtonPrimary>

            <ButtonDefault
              style={{ marginTop: '0.5rem' }}
              onClick={onLinkAccount}
            >
              Link Account
            </ButtonDefault>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BenefitOffer
